exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".card-wrapper {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 12px;\n  border-bottom: solid 2px #f4f9ff;\n}\n.search-input {\n  width: 300px !important;\n  border-radius: 5px;\n}", ""]);

// exports
